<template>
  <div class="comment-like">
    <!--评论-->
    <div class="comment-box">
      <div class="title">评论（{{ detail.comment_count }}）</div>
      <DetailComment
          :position="position"
          :detail="detail"
          :list="list"
          :pagination="pagination"
          :type="type"
          @getCommentList="getCommentList"
          @refresh="refresh"
      ></DetailComment>
    </div>
    <!--返回-->
    <DetailBack :position="position" v-if="!hideBack"></DetailBack>
    <!--返回首页-->
    <DetailBackHome :position="position" @goBackHome="goBackHome"
                    :style="[{top: hideBack ? '75px' : '125px'}]"></DetailBackHome>
    <!--侧边栏-->
    <DetailAside
        :position="position"
        :detail="detail"
        :type="type"
        :showOptions="showAsideOptions"
        @comment="onClickComment"
    ></DetailAside>
    <!--回到顶部-->
    <DetailScrollTop :position="position"></DetailScrollTop>
    <!--评论弹窗-->
    <el-dialog :visible.sync="dialogVisible" width="684px" :close-on-click-modal="true" custom-class="comment-dialog"
               top="10vh" :title="`评论（${detail.comment_count}）`">
      <DetailComment :detail="detail" :position="position" :list="list" @getCommentList="getCommentList"
                     :pagination="pagination" @refresh="refresh" :type="type"></DetailComment>
      <div class="flow-body">
        <div class="item" @click="onLike">
          <img class="icon" :src="`${detail.is_like
            ? require('@/assets/images/aside_dianzanle.png')
            : require('@/assets/images/aside_dianzan.png')
            }`
            "/>
          <span class="txt">{{ formatCount(detail.like_count) }}</span>
        </div>
        <div class="item" @click="onShare">
          <img class="icon" :src="`${require('@/assets/images/aside_fenxiang.png')}`"/>
          <span class="txt">分享</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// components
import DetailComment from '../../../detail/components/detailComment.vue'
import DetailBackHome from '../../../detail/components/detailBackHome.vue'
import DetailAside from "../../../detail/components/detailAside.vue"
import DetailScrollTop from "../../../detail/components/detailScrollTop.vue"
import DetailBack from '../../../detail/components/detailBack.vue'

// apis
import { apiCommentList } from "@/api/commentApi"
import { apiLikeCount, apiContentLike } from "@/api/contentApi"

import { mapGetters } from 'vuex'

// plugins
import Clipboard from "clipboard"
import { debounce } from '@/plugins/util'

export default {
  name: 'CommentLikeComponent',
  components: { DetailComment, DetailBackHome, DetailAside, DetailScrollTop, DetailBack },
  props: {
    type: {
      type: Number,
      require: false,
      default: 0
    },
    order: {
      type: Number,
      require: false,
      default: 1 // 默认正序排列
    },
    hideBack: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  data() {
    return {
      detail: {
        id: 0,
        like_count: 0,
        comment_count: 0,
        is_like: 0
      },
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      showAsideOptions: {
        avatar: false,
        like: true,
        favorite: false,
        comment: true,
        shareImage: false,
        shareText: true,
        goEdit: true
      },
      list: [],
      position: null,
      dialogVisible: false
    }
  },
  computed: {
    ...mapGetters(['loginUser'])
  },
  beforeMount() {
    this.detail.id = Number(this.$route.params.id)
    this.getLikeCount()
    this.getCommentList()
  },
  async mounted() {
    await this.$nextTick()
    window.addEventListener("resize", () => {
      this.watchPosition()
    })
    this.watchPosition()
    setTimeout(() => {
      window.addEventListener("scroll", this.watchPosition)
    }, 100)
  },
  methods: {
    watchPosition() {
      const el = document.querySelector('.wiki-detail') || document.querySelector('.zsca-content') || document.querySelector('.quilt-card-container')

      if (!el) return
      const { top, left, right, bottom } = el.getBoundingClientRect()
      this.position = {
        top,
        left,
        right,
        bottom
      }
    },
    getCommentList(type) {
      if (type === 'refresh') {
        this.pagination = {
          limit: 10,
          page_no: 0,
          page_total: 1,
          total: 0
        }
        this.list = []
      }
      if (this.pagination.page_no >= this.pagination.page_total) {
        this.loadCommentStatus = "end"
        return
      }
      ++this.pagination.page_no
      let params = {
        ...this.pagination,
        content_id: this.detail.id,
        type: this.type,
        order: this.order
      }
      apiCommentList(params).then(res => {
        if (res.code === 0) {
          this.list = this.list.concat(res.data)
          this.pagination = res.meta.pagination
          this.detail.comment_count = res.meta.pagination.total
        }
      })
    },
    getLikeCount() {
      const params = {
        origin_id: this.detail.id,
        type: this.type
      }
      apiLikeCount(params).then(res => {
        if (res.code === 0) {
          this.detail.like_count = res.data.total_count
          this.detail.is_like = res.data.is_like
        }
      })
    },
    refresh(detail, user) {
      // 将服务端数据置空，防止动态切换默认渲染此数据
      this.$store.commit("set_ssr_component_data", [])
      if (detail) {
        this.$set(this, "detail", detail)
      }
      if (user) {
        this.$set(this, "user", user)
      }
    },
    goBackHome() {
      this.$store.commit("set_ssr_component_data", [])
      this.$router.replace(`/${this.alias}`).then(() => {
        window.location.reload()
      })
    },
    onClickComment() {
      this.dialogVisible = true
    },
    onLike: debounce(function () {
      let params = {
        is_like: this.detail.is_like ? 0 : 1,
        origin_id: this.detail.id,
        type: this.type
      }
      apiContentLike(params).then(res => {
        if (res.code === 0) {
          this.detail.is_like = params.is_like
          params.is_like ? this.detail.like_count++ : this.detail.like_count--
          if (this.detail.like_count < 0) this.detail.like_count = 0
        }
      })
    }, 100),
    onShare() {
      let shareText = `${this.loginUser.username}分享了文章\r\n`
      shareText += window.location.href + "\r\n"
      shareText += "来自GameKee"

      let $div = document.createElement("div")
      $div.setAttribute("data-clipboard-text", shareText)
      $div.classList.add("page-share-copy-btn")
      document.body.appendChild($div)
      let clipboard = new Clipboard(".page-share-copy-btn")
      clipboard.on("success", e => {
        this.$message("复制成功！")
        document.body.removeChild($div)
        clipboard.destroy()
      })
      clipboard.on("error", e => {
        // 不支持复制
        this.$message("浏览器不支持自动复制,请更换其他浏览器")
        document.body.removeChild($div)
        clipboard.destroy()
      })
      $div.click()
    },
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿"
        } else {
          return (count / 100000000).toFixed(1) + "亿+"
        }
      } else if (count >= 10000) {
        const num = count / 10000
        if (num == (count / 10000).toFixed(1)) {
          return num + "W"
        } else {
          return (count / 10000).toFixed(1) + "W+"
        }
      } else if (count >= 1000) {
        const num = count / 1000
        if (num == (count / 1000).toFixed(1)) {
          return num + "K"
        } else {
          return (count / 1000).toFixed(1) + "K+"
        }
      } else {
        return count
      }
    },
  }
}
</script>

<style lang="less" scoped>
.comment-like {
  background: #fff;
  padding: 0 36px 10px 36px;

  .comment-box {
    margin-top: 30px;

    .title {
      font-weight: 500;
      font-size: 16px;
      color: #424242;
      line-height: 52px;
    }

    .wiki-detail-comment {
      height: 80vh;
    }
  }
}

/deep/ .comment-dialog {
  border-radius: 16px;

  .el-dialog__header {
    padding: 20px 32px 0;

    .el-dialog__headerbtn {
      right: 32px;
      top: 22px;
    }
  }

  .el-dialog__body {
    padding: 22px 32px;
  }
}

.flow-body {
  position: absolute;
  bottom: 20px;
  right: -74px;
  display: flex;
  flex-direction: column;
  gap: 14px;

  .item {
    width: 58px;
    height: 58px;
    border-radius: 30px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 14px;
    cursor: pointer;

    .icon {
      font-size: 0;
      width: 28px;
      height: 28px;
    }

    .txt {
      color: #424242;
      font-size: 11px;
    }
  }
}
</style>
